import api from '../../api/axios';
import { showError } from '../../Components/reuse/Toast';

export const CALL_PACKAGES_LIST_REQUEST = 'CALL_PACKAGES_LIST_REQUEST';
export const CALL_PACKAGES_LIST_SUCCESS = 'CALL_PACKAGES_LIST_SUCCESS';
export const CALL_PACKAGES_LIST_FAILURE = 'CALL_PACKAGES_LIST_FAILURE';

export const getAllCallPackages = ({
  status,
  planName,
  interval,
  company,
  email,
  fromDate,
  toDate,
  page = 1,
  limit = 15,
} = {}) => async (dispatch) => {
  dispatch({ type: CALL_PACKAGES_LIST_REQUEST });
  try {
    const body = { 
      status, 
      planName, 
      interval, 
      company, 
      email, 
      fromDate, 
      toDate
    };
    const response = await api.post('packages/getAllCallPackages', body, { params: { page, limit } });
    const success = response?.data?.success === undefined ? true : response.data.success;
    if (success) {
      dispatch({ type: CALL_PACKAGES_LIST_SUCCESS, payload: response.data });
      return { success: true, data: response.data };
    }
    const message = response?.data?.message || 'Failed to fetch call packages';
    dispatch({ type: CALL_PACKAGES_LIST_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  } catch (error) {
    const message = error?.response?.data?.message || 'Failed to fetch call packages';
    dispatch({ type: CALL_PACKAGES_LIST_FAILURE, error: message });
    showError(message);
    return { success: false, error: message };
  }
};
